/**
 *
 */

//-----------------------------------------------------------------------
// 載入模組

//-----------------------------------------------------------------------
// defines

/** console 伺服器服務網址 */
export const SERVER_URL	= "https://tracker.inpress.global/api";

//-----------------------------------------------------------------------
/**
 * 對伺服器發出 http post 命令。
 * @param path		API 的路徑，會串在伺服器服務網址之後，同一類 API 的路經都相同。
 * @param api		API 種類，會串在 API 路徑之後，代表個別不同的功能。
 * @param params	傳入參數，JSON 物件，依照 API 種類決定內容。
 * @returns			回傳內容解析為 JSON 物件。
 */
export async function post(path: string, api: string, params: any) : Promise<any>
{
	return new Promise((resolve, reject) =>
	{
		fetch(SERVER_URL + path + api,
		{
			mode		: 'cors',
			cache		: 'no-cache',
			credentials	: 'include',
			headers		:
			{
				'Content-Type'	: 'application/json',
				'Accept'		: 'application/json',
			},
			method		: 'POST',
			redirect	: 'follow',
			referrer	: 'no-referrer',
			body		: JSON.stringify(params),
		}).then((response) =>
		{
			if(!response.ok)
			{
				reject(new Error(response.statusText));
			}
			else
				return response.json();
		}).then((json) =>
		{
			if(typeof json !== 'undefined')
			{
				console.log(JSON.stringify(json));
				resolve(json);
			}
		}).catch((e) =>
		{
			reject(e);
		});
	});
}